import { useState } from '@hookstate/core';
import HelpModalState from '../state/HelpModalState';

export default function useHelpModalState() {
  const state = useState(HelpModalState);

  return {
    get visible() {
      return state.get();
    },
    dispatchHelpModalVisibility(val: boolean) {
      state.set(val);
    },
    toggleHelpModal() {
      state.set((val: boolean) => !val);
    },
  };
}
